import React from 'react';
import { Lock } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

const PLAN_LABELS = {
  free: 'Free',
  premium: 'Premium',
  admin: 'Admin',
};

const PLAN_FEATURES = {
  premium: ['Unlimited trades', 'Full Discipline Score (9 components)', 'Nyx AI Coach (150 msg/week)', 'Behavior & Trade Analytics', 'Market Scanners (27+)', 'Algo Flows', 'Backtesting', 'PDF & Email Reports'],
};

export default function UpgradeModal({ message, requiredPlan, onClose }) {
  const navigate = useNavigate();
  const planLabel = PLAN_LABELS[requiredPlan] || requiredPlan;
  const features = PLAN_FEATURES[requiredPlan] || [];

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-gray-900 border border-gray-700 rounded-2xl p-6 w-full max-w-sm mx-4 shadow-2xl"
        onClick={e => e.stopPropagation()}
      >
        <div className="flex flex-col items-center text-center gap-3">
          <div className="w-12 h-12 rounded-full bg-yellow-500/10 flex items-center justify-center">
            <Lock className="w-6 h-6 text-yellow-400" />
          </div>
          <h2 className="text-white font-semibold text-lg">
            {planLabel} Plan Required
          </h2>
          {message && (
            <p className="text-gray-400 text-sm">{message}</p>
          )}
          {features.length > 0 && (
            <ul className="text-left w-full mt-1 space-y-1">
              {features.map(f => (
                <li key={f} className="flex items-center gap-2 text-gray-300 text-sm">
                  <span className="text-green-400">✓</span> {f}
                </li>
              ))}
            </ul>
          )}
          <p className="text-gray-500 text-xs mt-2">
            Upgrade to Premium to unlock this feature.
          </p>
          <button
            onClick={() => { onClose(); navigate('/'); }}
            className="mt-2 w-full py-2 rounded-lg bg-gray-700 hover:bg-gray-600 text-white text-sm transition"
          >
            Go Home
          </button>
          <button
            onClick={() => { onClose(); navigate('/profile?section=subscription'); }}
            className="w-full py-2 rounded-lg text-white text-sm font-semibold transition"
            style={{ background: 'linear-gradient(135deg, #6366f1, #818cf8)', boxShadow: '0 4px 14px rgba(99,102,241,0.35)' }}
          >
            Upgrade to Premium
          </button>
        </div>
      </div>
    </div>
  );
}
